import { useQuery } from '@tanstack/react-query';
import { useUser } from './useUser';

import { getPublishEventsApi } from '../utils/apis';

const usePublishEvent = ({ selectedStore }: { selectedStore: any }) => {
  const { user } = useUser();
  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: ['publish-events', user?.tenantName, selectedStore?.id],
    queryFn: () =>
      getPublishEventsApi({
        tenantName: user?.tenantName || '',
        storeId: selectedStore?.id || '',
      }),
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 0,
    enabled: !!user?.tenantName && !!selectedStore?.is_menu_configured,
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
  });

  return {
    data: data?.data,
    dataLoading: isLoading || isFetching,
    error,
    refetch,
  };
};

export default usePublishEvent;
